// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes slideInFromRight {
    0% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(0);
    }
}
@keyframes slideInFromBottom {
    0% {
        transform: translateY(100%);
    }
    100% {
        transform: translateY(0);
    }
}

.explore-page-sideview {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    right: 0;
    width: var(--exploreSideviewWidth);
    height: 100%;
    background-color: rgba(7, 7, 8, 0.9);
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    border-left: 1px solid #fff1;
    box-sizing: border-box;
    z-index: 5;
    animation: 0.3s cubic-bezier( 0.22, 0.88, 0.2, 1 ) 0s 1 slideInFromRight;
}

.explore-page-sideview-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
}
.explore-page-sideview-title {
    font-size: 24px;
    font-weight: 700;
    color: #fffc;
    font-family: var(--displayFont);
}
.explore-page-sideview-close-button {
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    background-color: #fff2;
}
.explore-page-sideview-close-button:hover {
    background-color: #fff3;
}
.explore-page-sideview-close-icon {
    width: 24px;
    margin: auto;
}

/* Content section */
.explore-page-sideview-content {
    display: flex;
    flex-direction: column;
    padding: 20px;
    padding-top: 10px;
    color: black;
    max-height: 100%;
    overflow-y: auto;
}

/* Scrollbars */
.explore-page-sideview-content::-webkit-scrollbar {
    width: 10px;
}
.explore-page-sideview-content::-webkit-scrollbar-track {
    background: transparent;
}
.explore-page-sideview-content::-webkit-scrollbar-thumb {
    background: #fff6;
}
.explore-page-sideview-content::-webkit-scrollbar-thumb:hover {
    background: #fff5;
}

.explore-page-sideview-info {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
    color: white;
}

/* Stat box */
.ess-stat-box {
    border-width: 1px;
    border-style: solid;
    border-radius: 3px;
    padding: 5px 8px;
    width: 100%;
    flex-grow: 1;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}
.ess-stat-title {
    font-size: 14px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 8px;
}
.ess-stat-icon {
    width: 24px;
}
.ess-stat-value {
    font-size: 14px;
    font-weight: 500;
}

/* On small width and large height make it come up from the bottom */
@media screen and (max-width: 800px) {
    .explore-page-sideview {
        display: flex;
        flex-direction: column;
        height: 100% !important;
        top: unset !important;
        bottom: 0;
        right: 0;
        left: 0;
        width: 100% !important;
        border-top: 1px solid #fff1;
        border-left: none !important;
        animation: 0.3s cubic-bezier( 0.22, 0.88, 0.2, 1 ) 0s 1 slideInFromBottom;
    }
    .ess-stat-box {
        flex-direction: column;
        width: 100% !important;
        padding: 8px !important;
    }
    .ess-stat-title {
        font-size: 12px !important;
        font-weight: 600 !important;
        gap: 5px !important;
        width: 100%;
    }
    .ess-stat-icon {
        width: 18px;
    }
    .ess-stat-value {
        font-size: 14px;
        font-weight: 500;
        width: 100%;
    }
}

/* Content section error */
.explore-page-sideview-nosub-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    color: #fffd;
    font-size: 14px;
}
.explore-page-sideview-nosub-error {
    font-size: 16px;
    font-weight: 500;
    color: rgba(241, 121, 121, 0.949);
    border: 1px solid rgba(241, 121, 121, 0.949);
    border-radius: 8px;
    padding: 10px 20px;
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    margin: auto;
}

.download-button {
    width: 100%;
    padding: 8px 10px;
    box-sizing: border-box;
    background-color: rgb(51, 156, 53);
    border: 0;
    border-radius: 3px;
    font-family: var(--paragraphFont);
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 5px;
    cursor: pointer;
}
.download-button:hover {
    background-color: rgb(51, 156, 53, 0.9);
}`, "",{"version":3,"sources":["webpack://./src/styles/explore/ExploreSideview.css"],"names":[],"mappings":"AAAA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,kCAAkC;IAClC,YAAY;IACZ,oCAAoC;IACpC,kCAA0B;YAA1B,0BAA0B;IAC1B,4BAA4B;IAC5B,sBAAsB;IACtB,UAAU;IACV,wEAAwE;AAC5E;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;AACnC;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,YAAY;AAChB;;AAEA,aAAa;AACb;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,oEAAoE;AACpE;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,qBAAqB;QACrB,SAAS;QACT,QAAQ;QACR,OAAO;QACP,sBAAsB;QACtB,2BAA2B;QAC3B,4BAA4B;QAC5B,yEAAyE;IAC7E;IACA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,uBAAuB;IAC3B;IACA;QACI,0BAA0B;QAC1B,2BAA2B;QAC3B,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,WAAW;IACf;AACJ;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,4CAA4C;IAC5C,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kCAAkC;IAClC,SAAS;IACT,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;AACA;IACI,uCAAuC;AAC3C","sourcesContent":["@keyframes slideInFromRight {\n    0% {\n        transform: translateX(100%);\n    }\n    100% {\n        transform: translateX(0);\n    }\n}\n@keyframes slideInFromBottom {\n    0% {\n        transform: translateY(100%);\n    }\n    100% {\n        transform: translateY(0);\n    }\n}\n\n.explore-page-sideview {\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: var(--exploreSideviewWidth);\n    height: 100%;\n    background-color: rgba(7, 7, 8, 0.9);\n    backdrop-filter: blur(5px);\n    border-left: 1px solid #fff1;\n    box-sizing: border-box;\n    z-index: 5;\n    animation: 0.3s cubic-bezier( 0.22, 0.88, 0.2, 1 ) 0s 1 slideInFromRight;\n}\n\n.explore-page-sideview-header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 20px;\n}\n.explore-page-sideview-title {\n    font-size: 24px;\n    font-weight: 700;\n    color: #fffc;\n    font-family: var(--displayFont);\n}\n.explore-page-sideview-close-button {\n    background-color: transparent;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 100%;\n    background-color: #fff2;\n}\n.explore-page-sideview-close-button:hover {\n    background-color: #fff3;\n}\n.explore-page-sideview-close-icon {\n    width: 24px;\n    margin: auto;\n}\n\n/* Content section */\n.explore-page-sideview-content {\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    padding-top: 10px;\n    color: black;\n    max-height: 100%;\n    overflow-y: auto;\n}\n\n/* Scrollbars */\n.explore-page-sideview-content::-webkit-scrollbar {\n    width: 10px;\n}\n.explore-page-sideview-content::-webkit-scrollbar-track {\n    background: transparent;\n}\n.explore-page-sideview-content::-webkit-scrollbar-thumb {\n    background: #fff6;\n}\n.explore-page-sideview-content::-webkit-scrollbar-thumb:hover {\n    background: #fff5;\n}\n\n.explore-page-sideview-info {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 20px;\n    color: white;\n}\n\n/* Stat box */\n.ess-stat-box {\n    border-width: 1px;\n    border-style: solid;\n    border-radius: 3px;\n    padding: 5px 8px;\n    width: 100%;\n    flex-grow: 1;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n}\n.ess-stat-title {\n    font-size: 14px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n.ess-stat-icon {\n    width: 24px;\n}\n.ess-stat-value {\n    font-size: 14px;\n    font-weight: 500;\n}\n\n/* On small width and large height make it come up from the bottom */\n@media screen and (max-width: 800px) {\n    .explore-page-sideview {\n        display: flex;\n        flex-direction: column;\n        height: 100% !important;\n        top: unset !important;\n        bottom: 0;\n        right: 0;\n        left: 0;\n        width: 100% !important;\n        border-top: 1px solid #fff1;\n        border-left: none !important;\n        animation: 0.3s cubic-bezier( 0.22, 0.88, 0.2, 1 ) 0s 1 slideInFromBottom;\n    }\n    .ess-stat-box {\n        flex-direction: column;\n        width: 100% !important;\n        padding: 8px !important;\n    }\n    .ess-stat-title {\n        font-size: 12px !important;\n        font-weight: 600 !important;\n        gap: 5px !important;\n        width: 100%;\n    }\n    .ess-stat-icon {\n        width: 18px;\n    }\n    .ess-stat-value {\n        font-size: 14px;\n        font-weight: 500;\n        width: 100%;\n    }\n}\n\n/* Content section error */\n.explore-page-sideview-nosub-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    color: #fffd;\n    font-size: 14px;\n}\n.explore-page-sideview-nosub-error {\n    font-size: 16px;\n    font-weight: 500;\n    color: rgba(241, 121, 121, 0.949);\n    border: 1px solid rgba(241, 121, 121, 0.949);\n    border-radius: 8px;\n    padding: 10px 20px;\n    width: 100%;\n    box-sizing: border-box;\n    text-align: center;\n    margin: auto;\n}\n\n.download-button {\n    width: 100%;\n    padding: 8px 10px;\n    box-sizing: border-box;\n    background-color: rgb(51, 156, 53);\n    border: 0;\n    border-radius: 3px;\n    font-family: var(--paragraphFont);\n    font-size: 16px;\n    font-weight: 500;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    column-gap: 5px;\n    cursor: pointer;\n}\n.download-button:hover {\n    background-color: rgb(51, 156, 53, 0.9);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
